import { render, staticRenderFns } from "./ItineraryPieceBooking.vue?vue&type=template&id=52478bf2&scoped=true&"
import script from "./ItineraryPieceBooking.vue?vue&type=script&lang=js&"
export * from "./ItineraryPieceBooking.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryPieceBooking.vue?vue&type=style&index=0&id=52478bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52478bf2",
  null
  
)

export default component.exports